import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h3 className="text-lg font-bold text-background-50 font-heading mb-4">91.cn com</h3>
            <p className="text-sm text-background-400 leading-relaxed">
              正版内容平台导航，为您提供全面的平台介绍、功能解析、使用指南和安全建议。
            </p>
          </div>
          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4">快速导航</h4>
            <div className="space-y-2">
              <Link to="/" className="block text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer whitespace-nowrap">首页</Link>
              <Link to="/category/platform-intro" className="block text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer whitespace-nowrap">平台介绍</Link>
              <Link to="/category/user-guide" className="block text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer whitespace-nowrap">使用指南</Link>
              <Link to="/category/faq" className="block text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer whitespace-nowrap">常见问题</Link>
            </div>
          </div>
          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4">更多资源</h4>
            <div className="space-y-2">
              <Link to="/category/features" className="block text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer whitespace-nowrap">功能解析</Link>
              <Link to="/category/safety" className="block text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer whitespace-nowrap">安全建议</Link>
              <Link to="/about" className="block text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer whitespace-nowrap">关于我们</Link>
            </div>
          </div>
          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4">联系方式</h4>
            <div className="space-y-2 text-sm text-background-400">
              <p>邮箱：service@91cn.com</p>
              <p>客服：7×24小时在线</p>
              <p>地址：中国北京市</p>
            </div>
          </div>
        </div>
        <div className="border-t border-background-800/50 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">© 2026 91.cn com 正版内容平台导航. 保留所有权利.</p>
          <div className="flex items-center gap-4 text-xs text-background-500">
            <a href="#" className="hover:text-background-300 transition-colors cursor-pointer whitespace-nowrap">隐私政策</a>
            <a href="#" className="hover:text-background-300 transition-colors cursor-pointer whitespace-nowrap">使用条款</a>
            <a href="#" className="hover:text-background-300 transition-colors cursor-pointer whitespace-nowrap" rel="nofollow">网站地图</a>
          </div>
        </div>
      </div>
    </footer>
  );
}